import { render } from "./MyPolicies.vue?vue&type=template&id=10ec53ee&scoped=true"
import script from "./MyPolicies.vue?vue&type=script&lang=js"
export * from "./MyPolicies.vue?vue&type=script&lang=js"

import "./MyPolicies.vue?vue&type=style&index=0&id=10ec53ee&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-10ec53ee"

export default script